<div class="text-center">
  <button class="w-100" type="button" app-mat-flat-button color="primary" (click)="onContinue()">
    Continue as {{ user.fullName }}
  </button>
  <div class="my-3">or</div>
  <button class="w-100" type="button" app-mat-button color="primary" (click)="onLogin()">
    Log into another account
  </button>
</div>
